var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { GET_WEIGHT_DISCREPANCY_DATA_REQUEST, getWeightDiscrepancyDataFailure, getWeightDiscrepancyDataSuccess, } from "../../actions";
import APIIN from "../../../utils/APIIN";
const getWeightDiscrepancy = (action) => __awaiter(void 0, void 0, void 0, function* () {
    console.log("getWeightDiscrepancy action", action.payload);
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.post("/report/admin/weight/dispute/records", action.payload)
                .then((response) => {
                resolve(response);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* getWeightDiscrepancyWorker(action) {
    try {
        const data = yield call(getWeightDiscrepancy, action);
        yield put(getWeightDiscrepancyDataSuccess(data));
    }
    catch (error) {
        yield put(getWeightDiscrepancyDataFailure(error));
    }
}
export function* watchGetWeightDiscrepancyData() {
    yield takeLatest(GET_WEIGHT_DISCREPANCY_DATA_REQUEST, getWeightDiscrepancyWorker);
}
